import PayerResponse from './PayerResponse';

export { serviceCodeLabel } from './PayerResponse';
export default PayerResponse;
